function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

export { _has as default };
